<template>
  <div class="top-content-wrap local-content-wrap">
    <div class="header-container">
      <div class="container">
        <div class="row">
          <div class="col-xs col-lg-12">
            <div class="header-claim">
              <div class="claim-title">
                <h1>
                  Auto lokal verkaufen - <br/>schnell und sicher
                </h1>
                <span>Termin online buchen und Angebot vor Ort erhalten</span>
              </div>
              <div class="claim-content">
                
                <ul>
                  <li>100 % kostenlos - keine versteckte Kosten</li>
                  <li>kein Risiko dank geprüfter PKW.de Partnerhändler</li>
                  <li>Geld in bar oder per Sofortüberweisung erhalten</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ContentWidgetForm />
    <Vorteile />
  </div>
</template>

<script>
import ContentWidgetForm from "./ContentWidgetForm";
import Vorteile from './Vorteile.vue';
import { redirectToEvaluation } from "../services/helpers";

export default {
  name: "Header",
  components: {
    ContentWidgetForm,
    Vorteile
  },
  methods: {
    makeRedirect() {        
      redirectToEvaluation(this.$store);
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/vars";

a:hover {
  text-decoration: none !important;
}

body {
  font-family: "Asap", sans-serif !important;
}

// redesign code
.top-content-wrap,
.top-content-wrap * {
  font-family: "Asap", sans-serif;

  i {
    font-family: 'font awesome 5 free';
  }
}

hr {
  border: 0 none;
  background: $border-dark;
  height: 1px;
  width: 100%;
}

.top-content-wrap.local-content-wrap {
  // .inner-wrapper {
  //   max-width: 1620px;
  //   margin: 0 auto;
  //   height: 100%;
  //   padding: 40px 18px;
  // }

  .header-container {
    background-image: url("../assets/local/bg-header-local-small.jpg");
    background-size: cover;
    background-position: center;
    position: relative;
    padding-top:35px;
    padding-bottom:35px;

    &:before {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.45);
    }

    @include breakpoint(smallmedium) {
      background-position: center;
    }

    @include breakpoint(frommediumlarge) {
      background-image: url("../assets/local/bg-header-local-medium.jpg");
      padding-top:55px;
      padding-bottom:60px;
    }

    @include breakpoint(fromgiant) {
      padding-top: 165px;
      padding-bottom: 229px;
      background-image: url("../assets/local/bg-header-local.jpg");
      background-position: center center;

      
    }

    @media screen and (min-width:1200px) and (max-height:930px) {
      padding-top:45px;
      padding-bottom:195px;
    }

    @media screen and (min-width:1200px) and (max-height:950px) {
      padding-bottom:180px;
    }

    @include breakpoint(extralarge) {
      background-position: center;
    }

    .header-claim {
      .claim-title {
        color:$white;
        padding-left:0 !important;

        &:before {
          display:none !important;
        }

        @include breakpoint(frommediumlarge) {
          margin-bottom: 34px;
        }
        @include breakpoint(extralarge) {
          margin-bottom: 40px;
        }

        @media screen and (min-width:1200px) and (max-height:950px) {
          h1 {
            font-size:50px !important;
            line-height:60px !important;
          }
        }

        h1 {
          position: relative;
          padding-left: 14px;

          &:before {
            content:"";
            display:block;
            width: 3px;
            height: 100%;
            background-color: $white;
            left:0;
            top:50%;
            transform:translateY(-50%);
            position:absolute;
          }
        }

        span {
          display:block;
          font-size:20px;
          line-height:28px;
          margin-bottom:15px;

          @include breakpoint(frommediumlarge) {
            font-size:26px;
            line-height:40px;
          }

          @include breakpoint(fromlarge) {
            padding-left: 14px;
          }
        }
      }
      .claim-content {
        ul {
          padding-left: 0;

          @include breakpoint(fromlarge) {
            padding-left: 14px;
          }

          li {
            font-weight: 600;
            font-size: 15px;
            line-height: 22px;
            padding-left: 23px;
            position: relative;
            margin-bottom: 8px;
            color:$white;

            @include breakpoint(frommediumlarge) {
              font-size: 20px;
              line-height: 30px;
              padding-left: 36px;
            }

            @include breakpoint(fromgiant) {

              br {
                display: none;
              }
            }

              &:before {
                    content: "\f00c";
                    font-family: 'Font Awesome 5 Free';
                    font-weight: 700;
                    display: block;
                    color: $green-light;
                    font-size: 18px;
                    position: absolute;
                    left: 0;
                    top: 0;
                    background:none;
                }
          }
        }
      }
    }
  }

  section.online-verkaufen-fahrzeugwert {
    padding-top:20px;
    padding-bottom: 30px;

    @include breakpoint(frommediumlarge) {
      padding-top: 36px;
      padding-bottom: 60px;
    }

    @include breakpoint(fromgiant) {
      padding-top: 76px;
      padding-bottom: 110px;
    }

    h2 {
      br {
        display:none;
        @include breakpoint(fromlarge) {
          display:block;
        }
      }
    }
  }

  .teaser-wrap-row {
    padding-top: 10px;

    @include breakpoint(frommediumlarge) {
      padding-top:23px;
    }

    @include breakpoint(fromgiant) {
      padding-top: 35px;
      padding-bottom: 55px;
    }

    .teaser-block {
      margin-bottom:23px;
      @include breakpoint(frommediumlarge) {
         margin-bottom:55px;

         &:last-of-type {
           margin-bottom:43px;
         }
      }
      @include breakpoint(fromgiant) {
         margin-bottom:0;

         &:last-of-type {
           margin-bottom:0;
         }
      }
      br {
        display:none;
        @include breakpoint(frommediumlarge) {
          
          &:nth-of-type(2) {
            display:none;
          }
        }
        @include  breakpoint(extralarge) {
          display:block;
        }
      }

      .icon-block {
        margin-bottom: 13px;

        @include breakpoint(frommediumlarge) {
            margin-bottom:30px;
        }

        img {
          height:76px;

          @include breakpoint(frommediumlarge) {
            height:auto;
          }
        }
      }
      .teaser-title {
        
        @include breakpoint(frommediumlarge) {
          padding-bottom: 12px;
        }
      }
    }
  }

  .funktioniert-online-verkauf {
    padding-top: 25px;

    @include breakpoint(fromgiant) {
      display:block;
      padding-top:0;
    }
    .action-block {
      padding-top:20px;
      margin-bottom:35px;
      @include breakpoint(frommediumlarge) {
        padding-top: 0;
        margin-bottom: 50px;
      }
      @include breakpoint(fromgiant) {
        padding-top: 61px;
        margin-bottom: 75px;
      }
    }
  }

  ul.step-list {
    padding: 15px 0 0;
    width: 100%;

    @include breakpoint(fromlarge) {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    @include breakpoint(fromgiant) {
      padding: 25px 0 0;
    }

    @include breakpoint(extralarge) {
      padding: 25px 50px 0;
    }

    li {
      
      width:100%;
      position:relative;

      @include breakpoint(fromlarge) {
        width:20%;
        text-align: center;
      }

      .step-block {
        display:flex;
        align-items: center;
        margin-bottom:20px;

        @include breakpoint(frommediumlarge) {
          margin-bottom:40px;
        }

        @include breakpoint(fromlarge) {
          display:block;
          padding:0 10px;
        }

        @include breakpoint(fromgiant) {
          margin-bottom:0;
        }

        @include breakpoint(full) {
          padding:0;
        }

        br {
          display:none;
          @include breakpoint(full) {
            display:block;
          }
        }

        img {
          width:75px;
          margin-right:22px;

          @include breakpoint(fromlarge) {
            margin-right:0;
          }

          @include breakpoint(fromgiant) {
            width:auto;
            
          }
        }

        p {
          margin-bottom:0;
          @include breakpoint(fromlarge) {
            font-size:16px;
          }

          @include breakpoint(full) {
            font-size: 18px;
            
          }
        }
      }

      &:last-of-type {
        &:after {
          display:none;
        }
      }
      
      @include breakpoint(fromlarge) {
        &:after {
          content:"";
          display:block;
          height: 1px;
          background: $border-dark;
          width: 63px;
          position:absolute;
          right:-35px;
          top:40px;
        }
      }

      @include breakpoint(fromgiant) {
        &:after {
          top:63px;
        }
      }
      img {       

        @include breakpoint(fromgiant) {
          margin-bottom: 26px;
        }
      }
    }
  }

  .contact-container {
    background:$light-gray;
    border-radius: 12px;
    margin-top: 35px;

    @include breakpoint(frommediumlarge) {
      margin-top: 55px;
    }

    @include breakpoint(fromgiant) {
      background:transparent;
      border-radius:0;
      margin-top:0;
    }
  }

  .contact-block {
    background: $light-gray;
    border-radius: 12px;
    padding: 26px 0 34px;
    text-align:center;

    @include breakpoint(frommediumlarge) {
      padding:50px 0 62px;
    }

    @include breakpoint(fromgiant) {
      padding: 50px 0;
      margin-top: 75px;
      padding: 50px 30px;
      text-align:left;
    }

    @include breakpoint(extralarge) {
      padding: 50px 60px;
    }

    @include breakpoint(full) {
      padding: 50px 135px;
    }

    .inner-wrap {    

      @include breakpoint(fromgiant) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      p {
        margin-bottom: 0;
        font-size: 20px;
        line-height: 30px;

        @include breakpoint(fromgiant) {
          font-size: 24px;
          line-height: 32px;
        }

         @include breakpoint(extralarge) {
          font-size: 30px;
          line-height: 50px;
        }

        strong {
          display:block;

          @include breakpoint(frommediumlarge) {
            display:inline;
          }
        }
      }

      .action-block {
        padding-top:20px;
        text-align:center;
        flex-direction: column;
        display:flex;
        align-items: center;
        .btn:first-of-type {
          margin-bottom:25px;

          @include breakpoint(frommediumlarge) {
            margin-right: 47px;
            margin-bottom:0;
          }
        }

        @include breakpoint(frommediumlarge) {
          text-align:left;
          justify-content: center;
          flex-direction: row;
        }

        @include breakpoint(fromgiant) {
          padding-top:0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/local-components/Header.vue